import createIcon from '../../createIcon';

/**
 * @component @name JoinLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTcuNzRDMTMuNjU2OSAxNy43NCAxNSAxNS4xNzAxIDE1IDEyQzE1IDguODI5ODkgMTMuNjU2OSA2LjI2IDEyIDYuMjZDMTAuMzQzMSA2LjI2IDkgOC44Mjk4OSA5IDEyQzkgMTUuMTcwMSAxMC4zNDMxIDE3Ljc0IDEyIDE3Ljc0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTcuNSAxMkM3LjUgMTEuMDMgNy43MyA3Ljg0IDEwLjUzIDUuNUM5Ljc1IDUuMTkgOC45IDUgOCA1QzQuMTQgNSAxIDguMTQgMSAxMkMxIDE1Ljg2IDQuMTQgMTkgOCAxOUM4LjkgMTkgOS43NSAxOC44MSAxMC41MyAxOC41QzcuNzMgMTYuMTYgNy41IDEyLjk3IDcuNSAxMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNiA1QzE1LjEgNSAxNC4yNSA1LjE5IDEzLjQ3IDUuNUMxNC4wOCA2LjAxIDE0LjU3IDYuNTcgMTQuOTYgNy4xM0MxNS4yOSA3LjA1IDE1LjY0IDcgMTYgN0MxOC43NiA3IDIxIDkuMjQgMjEgMTJDMjEgMTQuNzYgMTguNzYgMTcgMTYgMTdDMTUuNjQgMTcgMTUuMjkgMTYuOTUgMTQuOTYgMTYuODdDMTQuNTcgMTcuNDMgMTQuMDggMTcuOTkgMTMuNDcgMTguNUMxNC4yNSAxOC44MSAxNS4xIDE5IDE2IDE5QzE5Ljg2IDE5IDIzIDE1Ljg2IDIzIDEyQzIzIDguMTQgMTkuODYgNSAxNiA1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const JoinLeft = createIcon('JoinLeft', [
  [
    'path',
    {
      d: 'M12 17.74C13.6569 17.74 15 15.1701 15 12C15 8.82989 13.6569 6.26 12 6.26C10.3431 6.26 9 8.82989 9 12C9 15.1701 10.3431 17.74 12 17.74Z',
      key: '17foac',
    },
  ],
  [
    'path',
    {
      d: 'M7.5 12C7.5 11.03 7.73 7.84 10.53 5.5C9.75 5.19 8.9 5 8 5C4.14 5 1 8.14 1 12C1 15.86 4.14 19 8 19C8.9 19 9.75 18.81 10.53 18.5C7.73 16.16 7.5 12.97 7.5 12Z',
      key: '1jltbq',
    },
  ],
  [
    'path',
    {
      d: 'M16 5C15.1 5 14.25 5.19 13.47 5.5C14.08 6.01 14.57 6.57 14.96 7.13C15.29 7.05 15.64 7 16 7C18.76 7 21 9.24 21 12C21 14.76 18.76 17 16 17C15.64 17 15.29 16.95 14.96 16.87C14.57 17.43 14.08 17.99 13.47 18.5C14.25 18.81 15.1 19 16 19C19.86 19 23 15.86 23 12C23 8.14 19.86 5 16 5Z',
      key: '1w96ya',
    },
  ],
]);

export default JoinLeft;
